// extracted by mini-css-extract-plugin
module.exports = {"service-item":"service-item","serviceItem":"service-item","list-services":"list-services","listServices":"list-services"};